class storage {
  get(key) {
    const value = sessionStorage.getItem(key);

    // 判断获取的元素是否为JSON
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  }
  set(key, value) {
    // 判断value是否为对象，将其转换成JSON格式
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  }
  remove(key) {
    sessionStorage.removeItem(key);
  }
  clear() {
    sessionStorage.clear();
  }
}
export default new storage();
